import clsx from 'clsx';
import { Base } from '../Base';
import { SrOnly } from '../Helper/SrOnly/SrOnly';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Dots-root_WFBVz",
  "icon": "Dots-icon_hULpH",
  "pulse": "Dots-pulse_1hG6n",
  "theme-light": "Dots-theme-light_13XXB",
  "theme-dark": "Dots-theme-dark_ru1oI"
};
const Dot = () => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 5 5",
  width: "5",
  height: "5",
  className: styles.icon,
  "aria-hidden": true,
  children: /*#__PURE__*/_jsx("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5"
  })
});
function Dots({
  title,
  theme = 'light',
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    flex: true,
    flexJustifyBetween: true,
    className: clsx(styles.root, styles[`theme-${theme}`], className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(SrOnly, {
      children: title
    })]
  });
}
export default Dots;